import Layout from '../views/layout/Layout'
import RouteView from '../views/layout/RouteView'

const accountComponent = () => import('@/views/adversiterManager/accountList/index')
const rebateComponent = () => import('@/views/recharge/productsRebateInfo/index')
const rechargeComponent = () => import('@/views/accounting/customerAdversiterMoney/index')

const productPageComponents = {
  qianchuan: {
    account: () => import('@/views/productOperations/qianchuan/AccountList'),
    rebate: () => import('@/views/productOperations/qianchuan/RebateList'),
    recharge: () => import('@/views/productOperations/qianchuan/RechargeList')
  },
  ad: {
    account: () => import('@/views/productOperations/ad/AccountList'),
    rebate: () => import('@/views/productOperations/ad/RebateList'),
    recharge: () => import('@/views/productOperations/ad/RechargeList')
  },
  localPush: {
    account: () => import('@/views/productOperations/localPush/AccountList'),
    rebate: () => import('@/views/productOperations/localPush/RebateList'),
    recharge: () => import('@/views/productOperations/localPush/RechargeList')
  },
  xingtu: {
    account: () => import('@/views/productOperations/xingtu/AccountList'),
    rebate: () => import('@/views/productOperations/xingtu/RebateList'),
    recharge: () => import('@/views/productOperations/xingtu/RechargeList')
  },
  kuaishou: {
    account: () => import('@/views/productOperations/kuaishou/AccountList'),
    rebate: () => import('@/views/productOperations/kuaishou/RebateList'),
    recharge: () => import('@/views/productOperations/kuaishou/RechargeList'),
    reserveOverview: () => import('@/views/productOperations/kuaishou/ReserveOverview')
  },
  tencent: {
    account: () => import('@/views/productOperations/tencent/AccountList'),
    rebate: () => import('@/views/productOperations/tencent/RebateList'),
    recharge: () => import('@/views/productOperations/tencent/RechargeList'),
    reserveOverview: () => import('@/views/productOperations/tencent/ReserveOverview')
  },
  tiktok: {
    account: () => import('@/views/productOperations/tiktok/AccountList'),
    rebate: () => import('@/views/productOperations/tiktok/RebateList'),
    recharge: () => import('@/views/productOperations/tiktok/RechargeList'),
    reserveOverview: () => import('@/views/productOperations/tiktok/ReserveOverview')
  }
}

function productGroup(options) {
  const base = `/businessCenter/${options.path}`
  const hasReserveOverview = Boolean(options.pages.reserveOverview)
  const children = [
    {
      path: 'accountList',
      name: options.routePrefix + 'AccountList',
      sort: 0,
      morePath: `${base}/accountList`,
      component: options.pages.account,
      meta: { title: '账户列表', icon: 'ad-list', productScoped: true, productTabId: options.tabId, productId: options.productId, productName: options.title }
    },
    {
      path: 'rechargeList',
      name: options.routePrefix + 'RechargeList',
      sort: 1,
      morePath: `${base}/rechargeList`,
      component: options.pages.recharge,
      meta: { title: '充值明细', icon: 'recharge-detail-list', productScoped: true, productId: options.productId, productName: options.title }
    }
  ]

  if (hasReserveOverview) {
    children.push(
      {
        path: 'reserveOverview',
        name: options.routePrefix + 'ReserveOverview',
        sort: 2,
        morePath: `${base}/reserveOverview`,
        component: options.pages.reserveOverview,
        meta: { title: '备款情况', icon: 'customer-money-list', productScoped: true, productId: options.productId, productName: options.title }
      },
      {
        path: 'customerReserve',
        name: options.routePrefix + 'CustomerReserveList',
        hidden: true,
        redirect: `${base}/reserveOverview`
      },
      {
        path: 'mediaReserve',
        name: options.routePrefix + 'MediaReserveList',
        hidden: true,
        redirect: `${base}/reserveOverview`
      }
    )
  }

  children.push({
    path: 'rebateList',
    name: options.routePrefix + 'RebateList',
    sort: hasReserveOverview ? 3 : 2,
    morePath: `${base}/rebateList`,
    component: options.pages.rebate,
    meta: { title: '返点列表', icon: 'rebateManger-list', productScoped: true, productId: options.productId, productName: options.title }
  })

  return {
    path: options.path,
    name: options.name,
    sort: options.sort,
    component: RouteView,
    redirect: `${base}/accountList`,
    meta: { title: options.title, icon: 'ad-list' },
    children
  }
}

function pendingProduct(path, name, title, routeName) {
  return {
    path,
    name,
    component: RouteView,
    redirect: `/businessCenter/${path}/comingSoon`,
    meta: { title: `${title}（待接入）`, icon: 'ad-list' },
    children: [{
      path: 'comingSoon',
      name: routeName,
      morePath: `/businessCenter/${path}/comingSoon`,
      component: () => import('@/views/productOperations/ComingSoon'),
      meta: { title: '接入说明', icon: 'ad-list', productName: title }
    }]
  }
}

const businessCenterRoutes = {
  path: '/businessCenter',
  component: Layout,
  redirect: '/businessCenter/qianchuan/accountList',
  defaultPath: '/businessCenter/qianchuan/accountList',
  name: 'businessCenter',
  meta: { title: '产品运营', icon: 'business-center', alwaysShow: true, clickable: false },
  children: [
    productGroup({ path: 'qianchuan', name: 'qianchuanOperations', sort: 0, routePrefix: 'qianchuan', title: '千川', productId: 6, tabId: 1, pages: productPageComponents.qianchuan }),
    productGroup({ path: 'ad', name: 'adOperations', sort: 1, routePrefix: 'ad', title: 'AD', productId: 7, tabId: 2, pages: productPageComponents.ad }),
    {
      path: 'overview',
      name: 'productOverview',
      sort: 2,
      component: RouteView,
      redirect: '/businessCenter/overview/accountList',
      meta: { title: '综合查询', icon: 'business-center' },
      children: [
        { path: 'accountList', name: 'allProductAccountList', sort: 0, morePath: '/businessCenter/overview/accountList', component: accountComponent, meta: { title: '总账户列表', icon: 'ad-list' } },
        { path: 'rechargeList', name: 'allProductRechargeList', sort: 1, morePath: '/businessCenter/overview/rechargeList', component: rechargeComponent, meta: { title: '总充值明细', icon: 'recharge-detail-list' } },
        { path: 'rebateList', name: 'allProductRebateList', sort: 2, morePath: '/businessCenter/overview/rebateList', component: rebateComponent, meta: { title: '总返点列表', icon: 'rebateManger-list' } }
      ]
    },
    productGroup({ path: 'localPush', name: 'localPushOperations', sort: 3, routePrefix: 'localPush', title: '本地推', productId: 8, tabId: 3, pages: productPageComponents.localPush }),
    productGroup({ path: 'xingtu', name: 'xingtuOperations', sort: 4, routePrefix: 'xingtu', title: '星图', productId: 9, tabId: 4, pages: productPageComponents.xingtu }),
    productGroup({ path: 'tiktok', name: 'tiktokOperations', sort: 5, routePrefix: 'tiktok', title: 'TikTok', tabId: 5, pages: productPageComponents.tiktok }),
    productGroup({ path: 'kuaishou', name: 'kuaishouOperations', sort: 6, routePrefix: 'kuaishou', title: '快手', pages: productPageComponents.kuaishou }),
    productGroup({ path: 'tencent', name: 'tencentOperations', sort: 7, routePrefix: 'tencent', title: '腾讯', pages: productPageComponents.tencent }),
    {
      path: '/businessCenter/adversiterManager/accountList',
      redirect: '/businessCenter/overview/accountList',
      hidden: true
    },
    {
      path: '/businessCenter/rechargeRebate/productsList',
      redirect: '/businessCenter/overview/rebateList',
      hidden: true
    },
    {
      path: '/finance/financialManagement/customeAdversiterMoney',
      redirect: '/finance/fundSettlement/rechargeDetail',
      hidden: true
    }
  ]
}

export default businessCenterRoutes



// WEBPACK FOOTER //
// ./src/router/business-center.js